import { BID_STRATEGIES } from 'modules/campaigns/modules/common-campaign-form/config/bidStrategies';
import { FILE_SIZE_KILOBYTES } from 'modules/campaigns/modules/creative-display/config/displayTypes';

const COMMON_FLAGS = {
    BID_MODIFICATION_BOOST_MIN_DEFAULT: 'backstage:min-cpc-boost-default',
    BID_MODIFICATION_BOOST_MAX_DEFAULT: 'backstage:max-cpc-boost-default',
    BID_MODIFICATION_BOOST_MIN_INTERNAL: 'backstage:min-cpc-boost-internal',
    BID_MODIFICATION_BOOST_MAX_INTERNAL: 'backstage:max-cpc-boost-internal',
    UNIP_BASE_CODE_SNIPPET: 'backstage:unip:base-pixel-default-code-snippet',
    UNIP_EVENT_CODE_SNIPPET: 'backstage:unip:event-default-code-snippet',
    UNIP_EVENT_CODE_SNIPPET_IMAGE_PIXEL_WITH_GTM: 'backstage:unip:conversion-image-pixel-default-code-snippet-with-gmt',
    UNIP_EVENT_CODE_SNIPPET_IMAGE_PIXEL_WITHOUT_GTM:
        'backstage:unip:conversion-image-pixel-default-code-snippet-without-gmt',
    UNIP_BASE_IMAGE_PIXEL_DEFAULT_CODE_SNIPPET_WITH_GTM:
        'backstage:unip:base-image-pixel-default-code-snippet-with-gmt',
    UNIP_BASE_IMAGE_PIXEL_DEFAULT_CODE_SNIPPET_WITHOUT_GTM:
        'backstage:unip:base-image-pixel-default-code-snippet-without-gmt',
    TARGET_CPA_MAX_CAMPAIGN_LEARNING_TIME_DAYS: 'sp-campaign-cvr-learning-status:max-campaign-learning-time-days',
    TARGET_CPA_MAX_CAMPAIGN_LEARNING_LIMITED_TIME_DAYS:
        'sp-campaign-cvr-learning-status:max-campaign-learning-limited-time-days',
    CVR_LEARNING_STATUS_MAX_TIME_IN_REVIEW_IN_HOURS: 'sp-campaign-cvr-learning-status:max-time-in-review-in-hours',
    CVR_LEARNING_STATUS_NUMBER_OF_CONVERSIONS_IN_TIMEFRAME_FOR_COMPLETION:
        'sp-campaign-cvr-learning-status:number-of-conversions-in-timeframe-for-completion',
    LOOKBACK_WINDOW_FOR_CONVERSIONS_DAYS: 'sp-campaign-cvr-learning-status:lookback-window-for-conversions-days',
    CVR_LEARNING_STATUS_MAX_TIME_TO_SHOW_PROGRESS_AFTER_COMPLETION_IN_HOURS:
        'sp-campaign-cvr-learning-status:max-time-to-show-progress-after-completion-in-hours',
    CVR_LEARNING_STATUS_MIN_LEARNING_DAYS_BEFORE_WARNING:
        'sp-campaign-cvr-learning-status:min-learning-days-before-warning',
    CVR_LEARNING_STATUS_MIN_LEARNING_PROGRESS_PERCENTAGE_BEFORE_WARNING:
        'sp-campaign-cvr-learning-status:min-learning-progress-percentage-before-warning',
    DCO_CREATIVE_TEMPLATE_REPORT_ENABLED: 'taboola-ads:campaign-report:dco-creative-template-report-enabled',
    DCO_ITEM_PERFORMANCE_REPORT_ENABLED: 'taboola-ads:campaign-report:dco-item-performance-report-enabled',
    STRIPE_PUBLIC_API_KEY: 'ccb:stripe-public-api-key',
    SITE_BLOCKING_MAX_VALUE: 'targeting-limit:syndicator:exclude',
    MOTION_ADS_WOCHIT_CHANNEL_ID: 'backstage:motion-ads:wochit-channel-id',
    RESUBMIT_CREATIVES_LANDING_PAGE_REJECTION_REASONS: 'resubmit-creatives:landing-page-reject-reasons',
    TARGET_CPA_ELIGIBILITY_LABELS: 'ads-console:target-cpa-eligibility-labels',
    PERFORMANCE_RECOMMENDATION_TCPA_SHOULD_USE_EDITABLE_CARD:
        'taboola-ads:performance-recommendation:tcpa:should-use-editable-card',
    CUSTOM_CONTEXTUAL_REACH_THRESHOLD: 'ads-console:custom-contextual:reach-threshold',
    CAMPAIGN_REACH_ESTIMATOR_THRESHOLD: 'ads-console:campaign-reach-estimator:threshold',
    CAMPAIGN_REACH_ESTIMATOR_LIMIT: 'ads-console:campaign-reach-estimator:limit',
    COMBINED_SEGMENTS_REACH_THRESHOLD: 'ads-console:combined-segments-reach-estimator:threshold',
    COMBINED_SEGMENTS_REACH_LIMIT: 'ads-console:combined-segments-reach-estimator:limit',
    SRT_AUDIENCES_SUPPORTED_COUNTRIES_LIST: 'ads-console:srt-audiences:supported-countries:list',
    MRT_AUDIENCES_SUPPORTED_COUNTRIES_LIST: 'ads-console:mrt-audiences:supported-countries:list',
    CRM_AUDIENCES_EMAILS_SUPPORTED_COUNTRIES_LIST: 'ads-console:crm-audiences:emails:supported-countries:list',
    CRM_AUDIENCES_DEVICE_IDS_SUPPORTED_COUNTRIES_LIST: 'ads-console:crm-audiences:device-ids:supported-countries:list',
    EXTERNAL_AUDIENCES_CONTENT_REVIEW_ENABLED: 'external-audiences:content-review:enabled',
    AUDIENCES_LONG_CREATION_TIME_INDICATION_ENABLED: 'ads-console:audiences-long-creation-time-indication:enabled',
    SCHEDULE_TRACKING_MEETING_URL: 'taboola-ads:tracking:schedule-meeting-url',
    PERMITTED_TIMEZONES_FOR_SCHEDULE_MEETING: 'taboola-ads:tracking:permitted-timezones-for-schedule-meeting',
    CAMPAIGN_LEVEL_CONVERSIONS_NUMBER_OF_CONVERSIONS_THRESHOLD:
        'ads-console:campaign-level-conversions:num-of-conversions-for-warning-threshold',
    CAMPAIGN_LEVEL_CONVERSIONS_DATA_LOOKBACK_WINDOW:
        'campaign-level-conversions:lookback-window-for-account-conversions-data',
    IS_AUTO_BLOCKED_SITES_FORM_EDITABLE: 'backstage-api:auto-publisher-targeting:is-allowed-to-update',
    TARGET_CPA_SIGNIFICANT_CHANGE_PERCENT: 'target-cpa:lifecycle-task:target-cpa-significant-change-percent',
    NOTIFICATIONS_CENTER_REFECTH_TIME: 'ads-console:notification-refetch-time',
    LEGAL_ENTITIES_REQUIRE_MANDATE_CONFIG: 'stripe:legal-entities-require-mandate',
    LEGAL_ENTITIES_PARTIAL_CC_BRANDS_SUPPORT: 'stripe:legal-entities-partial-cc-brands-support',
    COUNTRY_TO_LEGAL_ENTITIES_WITH_TAX_REGISTRATION: 'taboola-ads:country-to-legal-entities-with-tax-registration',
    SUPPORTED_COUNTRY_FOR_TAX_REGISTRATION: 'taboola-ads:supported-country-for-tax-registration',
    OUTCROPPING_IMAGE_NUM_IMAGES: 'taboola-ads:outcropping-image-num-images',
    OUTCROPPING_IMAGE_MIN_THRESHOLD: 'taboola-ads:outcropping-image-min-threshold',
    OUTCROPPING_IMAGE_MAX_THRESHOLD: 'taboola-ads:outcropping-image-max-threshold',
    UNREALISTIC_TCPA_SHOULD_RECOMMEND_TARGET: 'unrealistic-tcpa-recommendation:should-recommend-target',
    BID_MODIFICATION_DAY_TIME_BOOST_MIN_DEFAULT: 'day-time-bid-manager:min-multiplier-val',
    PLATFORM_BOOST_MIN_VALUE: 'backstage:min-cpc-boost-platform',
    PLATFORM_BOOST_MAX_VALUE: 'backstage:max-cpc-boost-platform',
    BACKSTAGE_MAIL_DOMAINS_RECOMMENDATIONS_VALUE: 'backstage:mail-domains-fetcher:max-domains-recommendation-count',
    BACKSTAGE_MAIL_DOMAINS_RECOMMENDATIONS_FETCH_DURATION_MS:
        'backstage:mail-domains-fetcher:max-domains-recommendation-fetch-duration-ms',
    CANCEL_PAYMENT_ALLOWED_PAYMENT_METHODS: 'billing:cancel-payment:allowed-payment-methods',
    CROPPING_SIGNIFICANT_CHANGE_THRESHOLD_KEY: 'backstage:creative:crop:significant-change-threshold',
    LOW_TIER_DAILY_LIMIT_VALIDATION_ENABLED: 'backstage:low-tier:enable-daily-limit-validation',
    GEN_AI_EDIT_DUPLICATE_TOOLTIP_MAX_CLOSES: 'taboola-ads:creative-studio:edit-duplicate-tooltip-max-closes',
    TA_PIXEL_WITH_TIER_WARNINGS: 'taboola-ads:pixel-with-tier-warnings',
    WIDE_PERFORMANCE_TABLE_DATA_RETENTION_IN_MONTHS: 'backstage:wide-performance-table-data-retention-in-month',
    CHAT_AGENT_ENABLED: 'taboola-ads:chat-agent:enabled',
    USE_PUBLISHER_DESCRIPTION_PREFIX_FOR_PUBLISHER: 'taboola-ads:use-publisher-description-prefix',
    BULK_UPLOAD_NUM_CAMPAIGNS_PER_BATCH: 'taboola-ads:bulk-upload:campaigns-per-batch',
    BULK_UPLOAD_NUM_CREATIVES_PER_BATCH: 'taboola-ads:bulk-upload:creatives-per-batch',
    LOADING_BAR_TIME_FOR_REPLACE_BACKGROUND: 'taboola-ads:loading-bar-time:replace-background',
    BULK_UPLOAD_MAX_CAMPAIGN_ROWS: 'backstage:max-bulk-upload-campaigns-size',
    BULK_UPLOAD_MAX_CREATIVES_ROWS: 'backstage:max-bulk-upload-campaign-items-size',
    MAX_ALLOWED_TERMS_NUMBER: 'taboola-ads:custom-contextual-segments:max-allowed-terms-number',
    MAX_CONVERSIONS_CPC_CAP_ENABLED: 'taboola-ads:cpc-cap:is-enabled',
    MIN_PBP_ELIGIBLE_SEED_EVENT_THRESHOLD: 'pbp-eligible-seed-received-event-count:threshold',
    SHOW_REGION_FOR_COUNTRIES: 'taboola-ads:billing:show-state-for-countries',
    ALLOW_CARTES_BANCAIRES: 'taboola-ads:billing:cartes-bancaires:is-enabled',
    CHAT_AGENT_FIX_BUTTON_LOADING_TIMEOUT: 'taboola-ads:creative-report:chat-fix-loading-timeout-ms',
    MRT_AUDIENCES_PREFIXES_TO_REMOVE_FROM_INPUT: 'taboola-ads:mrt-audiences:prefixes-to-remove-from-input',
    ADVANCED_PREVIEW_MAX_VARIATIONS: 'taboola-ads:advanced-preview-max-variations',
    HIDE_VATID_TOOLTIP_FOR_COUNTRIES: 'ads-console-vat-id-tooltip:excluded-countries',
    RBOX_IS_SUPPORTING_PREVIEW_HASH_PARAM: 'rbox:is-supporting-preview-hash-param',
    ADVANCED_PREVIEW_WITH_TRANSFORMATION: 'taboola-ads:advanced-preview-with-transformation',
    ADVANCED_PREVIEW_ENABLE_BUTTON_FOR_DISPLAY_AD: 'taboola-ads:advanced-preview-enable-button-for-display-ad',
    ADVANCED_PREVIEW_ENABLE_BUTTON_FOR_DISPLAY_CREATE: 'taboola-ads:advanced-preview-enable-button-for-display-create',
    ADVANCED_PREVIEW_ENABLE_TRC_TABOOLA_PARAMS_IN_NATIVE:
        'taboola-ads:advanced-preview-enable-trc-taboola-params-in-native',
    ADVANCED_PREVIEW_FORCE_NATIVE_QUERY_PARAMS: 'taboola-ads:advanced-preview-force-native-query-params',
    DISPLAY_SHOW_RESPONSIVE_CHECKBOX: 'taboola-ads:display-show-responsive-checkbox',
    MIN_CREATIVES_ONBOARDING_JOURNEY: 'taboola-ads:onboarding-journey:min-number-of-creatives',
    WARNING_THRESHOLD_MULTIPLIER: 'taboola-ads:onboarding-journey:warning-threshold-multiplier',
    ONBOARDING_JOURNEY_WARNING_COMPTITIVE_CPA_THRESHOLD:
        'taboola-ads:onboarding-journey:warning-threshold-competitive-cpa',
    ONBOARDING_JOURNEY_WARNING_CPA_TOO_LOW: 'taboola-ads:onboarding-journey:warning-cpa-too-low',
    ONBOARDING_JOURNEY_CPA_DEFAULT_TOLERANCE: 'taboola-ads:onboarding-journey:cpa-default-tolerance',
    ONBOARDING_JOURNEY_CREATIVES_WAITING_SCREEN_TIMEOUT:
        'taboola-ads:onboarding-journey-creatives-waiting-screen-timeout',
    ONBOARDING_JOURNEY_MIN_DAILY_BUDGET_FOR_CPC_MARKETING_OBJECTIVES:
        'taboola-ads:onboarding-journey-min-daily-budget:cpc-marketing-objectives',
    ONBOARDING_JOURNEY_MIN_DAILY_BUDGET_FOR_GENERAL_MARKETING_OBJECTIVES:
        'taboola-ads:onboarding-journey-min-daily-budget:non-cpc-marketing-objectives',
    PIXEL_TESTER_EVENTS_LIMIT: 'taboola-ads:pixel-tester:events-limit',
    PIXEL_TESTER_EVENTS_BLACK_LIST_PARAMETERS: 'taboola-ads:pixel-tester:events:black-list-parameters',
    PIXEL_TESTER_DEFAULT_SHOPIFY_EVENTS: 'taboola-ads:pixel-tester:default-shopify-events',
    PIXEL_TESTER_WEBSOCKET_SOURCE_FILTER: 'trc:unip:test-events:context-source-type',
    PIXEL_TESTER_TFA_VALIDATION_ENABLED: 'taboola-ads:pixel-tester-tfa-validation-enabled',
    ONBOARDING_JOURNEY_WEBSOCKET_SOURCE_FILTER: 'taboola-ads:onboarding-journey:websocket-source-filter',
    SHOW_STRIPE_LOGO_FOR_COUNTRIES: 'taboola-ads:billing:show-stripe-logo-for-countries',
    SHOW_FIXED_FEE_FOR_LEGAL_ENTITY: 'taboola-ads:billing:show-fixed-fee-for-legal-entity',
    SHOW_CUSTOM_VAT_TOOLTIP_FOR_COUNTRIES: 'taboola-ads:billing:show-custom-vat-tooltip-countries',
    APPLE_MAX_LENGTH_CREATIVE_TITLE_THRESHOLD: 'creative-max-length-threshold:apple-title',
    APPLE_MAX_LENGTH_CREATIVE_DESCRIPTION: 'creative-max-length:apple-description',
    MAIL_MAX_LENGTH_CREATIVE_TITLE_THRESHOLD: 'creative-max-length-threshold:mail-title',
    MAIL_MAX_LENGTH_CREATIVE_DESCRIPTION: 'creative-max-length:mail-description',
    PERFORMANCE_RULES_LOW_FREQUENCY_LOOK_BACK_WINDOW: 'performance-rule:action-frequency-window-size:low',
    PERFORMANCE_RULES_MEDIUM_FREQUENCY_LOOK_BACK_WINDOW: 'performance-rule:action-frequency-window-size:medium',
    PERFORMANCE_RULES_HIGH_FREQUENCY_LOOK_BACK_WINDOW: 'performance-rule:action-frequency-window-size:high',
    CAMPAIGN_DEFAULT_EXCLUDE_SHOULD_EXCLUDE_AUDIENCES_WITH_NO_SIZE:
        'taboola-ads:campaign-default-exclude:should-exclude-audiences-with-no-size',
    PACING_SCORE_STATUS_RANGE_BARRIERS: 'taboola-ads:campaigns-group-report:pacing-score:status-range-barriers',
    PACING_SCORE_MIN_VALUE_TO_SHOW: 'taboola-ads:campaigns-group-report:pacing-score:min-value-to-show',
    CREATIVES_THUMBNAIL_DEFAULT_SRC: 'taboola-ads:creatives-thumbnail-default-src',
    FREQUENCY_CAPPING_DAY_THRESHOLD: 'taboola-ads:frequency-cap-day-threshold',
    FREQUENCY_CAPPING_WEEK_THRESHOLD: 'taboola-ads:frequency-cap-week-threshold',
    FREQUENCY_CAPPING_MONTH_THRESHOLD: 'taboola-ads:frequency-cap-month-threshold',
    FREQUENCY_CAPPING_ALLOWED_TIERS: 'frequency-capping:allowed-tiers',
    CAMPAIGN_SIMULATOR_ENABLED_BIDDING_STRATEGIES: 'taboola-ads:campaign-simulator-enabled-bidding-strategies',
    PERFORMANCE_RULES_MAX_NUMBER_OF_SITE_NAMES: 'backstage:performance-rules:max-test-list-size',
    CAMPAIGN_SIMULATOR_TCPA_UNREALISTIC_FACTOR: 'taboola-ads:campaign-simulator-tcpa-unrealistic-factor',
    HIDDEN_CRA_TAGS_LIST: 'taboola-ads:hidden-cra-tags-list',
    CRA_TAG_COMMENT_CONTENT_BLACKLIST: 'taboola-ads:cra-tag-comment-content-blacklist',
    HOSTED_VIDEO_MIN_DURATION: 'taboola-ads:hosted-video-min-duration',
    HOSTED_VIDEO_MAX_DURATION: 'taboola-ads:hosted-video-max-duration',
    PREVIEW_POST_MESSAGE_ENABLE_NATIVE_ADS: 'taboola-ads:preview-placements:post-message-native-ads',
    HOSTED_MEDIA_VIDEO_MAX_FILE_SIZE_IN_KILOBYTES: 'backstage:display-creative-validations:max-video-size:kilo-bytes',
    HOSTED_MEDIA_IMAGE_MAX_FILE_SIZE_IN_KILOBYTES: 'backstage:display-creative-validations:max-image-size:kilo-bytes',
    HOSTED_MEDIA_ARCHIVE_MAX_FILE_SIZE_IN_KILOBYTES: 'backstage:display-creative-validations:max-zip-size:kilo-bytes',
    BULK_DUPLICATE_CAMPAIGNS_GROUPS_MAX_SIZE: 'backstage:max-bulk-duplicate-campaigns-groups-size',
    DUPLICATE_CAMPAIGNS_MAX_COPIES: 'taboola-ads:max-bulk-duplicate-campaigns-max-copies',
    STANDARD_DISPLAY_AD_DIMENSIONS: 'taboola-ads:standard-display-ad-dimensions',
    ENABLED_OPEN_TELEMETRY_UI: 'taboola-ads:enabled-open-telemetry-ui',
    SUPPLY_TARGETING_ICONS_TABOOLA_SELECT: 'ads-console:supply-targeting:icons:TABOOLA_SELECT',
    SUPPLY_TARGETING_MORE_ICONS_NUMBER_TABOOLA_SELECT: 'ads-console:supply-targeting:more-icons-number:TABOOLA_SELECT',
    SUPPLY_TARGETING_ICONS_EXTENDED_PREMIUM: 'ads-console:supply-targeting:icons:EXTENDED_PREMIUM',
    SUPPLY_TARGETING_MORE_ICONS_NUMBER_EXTENDED_PREMIUM:
        'ads-console:supply-targeting:more-icons-number:EXTENDED_PREMIUM',
    SUPPLY_TARGETING_ICONS_TABOOLA_CURATED: 'ads-console:supply-targeting:icons:TABOOLA_CURATED',
    SUPPLY_TARGETING_MORE_ICONS_NUMBER_TABOOLA_CURATED:
        'ads-console:supply-targeting:more-icons-number:TABOOLA_CURATED',
    PERFORMANCE_MEASUREMENT_REPORT_TYPE: 'taboola-ads:performance-measurement-report-type',
    PERFORMANCE_MEASUREMENT_REPORT_DATE_RANGE: 'taboola-ads:performance-measurement-report-filter-enabled',
    PERFORMANCE_MEASUREMENT_ACCOUNT_TYPE: 'taboola-ads:performance-measurement-account-type',
    PROFIT_MARGIN_MIN_VALUE_FOR_WARNING: 'taboola-ads:profit-margin-min-value-for-warning',
    CAMPAIGN_EDITOR_DRAWER_COLLAPSE_SECTIONS: 'taboola-ads:campaign-editor-drawer:collapse-sections',
    CCB_LEGAL_ENTITY_ENFORCE_CARD_ORIGIN_COUNTRY: 'ccb:validate:legal-entity-enforce-card-origin-country',
    SHOW_UI_MEMORY_LEAK_INDICATION: 'taboola-ads:show-memory-leak-indication',
    CODELESS_CRAWLER_API_TIMEOUT_MS: 'taboola-ads:codeless:crawler-api-timeout-ms',
    PERFORMANCE_METAMODEL_DIMENSIONS_DISPLAY_ORDER: 'taboola-ads:PERFORMANCE_REPORT:metamodel-dimensions-display-order',
    KOREAN_KG_INICIS_PAYMENT_PROVIDER_BANK_CODES:
        'ads-console:add-funds:bank-transfer:kg-inicis-supported-virtual-account-bank-codes',
    PIXEL_TESTER_DELAY_INFO_MESSAGE: 'taboola-ads:pixel-tester-delay-info-message',
    PIXEL_TESTER_SHOW_USER_MATCHING_CONSENT: 'taboola-ads:pixel-tester-show-user-matching-consent',
};

const defaultCommonValues = {
    [COMMON_FLAGS.BID_MODIFICATION_BOOST_MIN_DEFAULT]: -0.5,
    [COMMON_FLAGS.BID_MODIFICATION_BOOST_MAX_DEFAULT]: 0.5,
    [COMMON_FLAGS.BID_MODIFICATION_BOOST_MIN_INTERNAL]: -0.5,
    [COMMON_FLAGS.BID_MODIFICATION_BOOST_MAX_INTERNAL]: 1.5,
    [COMMON_FLAGS.UNIP_BASE_CODE_SNIPPET]:
        '<!-- Taboola Pixel Code -->\n' +
        "<script type='text/javascript'>\n" +
        '  window._tfa = window._tfa || [];\n' +
        "  window._tfa.push({notify: 'event', name: 'page_view', id: <NUMERIC_ADVERTISER_ID>});\n" +
        '  !function (t, f, a, x) {\n' +
        '         if (!document.getElementById(x)) {\n' +
        '            t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);\n' +
        '         }\n' +
        "  }(document.createElement('script'),\n" +
        "  document.getElementsByTagName('script')[0],\n" +
        "  '//cdn.taboola.com/libtrc/unip/<NUMERIC_ADVERTISER_ID>/tfa.js',\n" +
        "  'tb_tfa_script');\n" +
        '</script>\n' +
        '<!-- End of Taboola Pixel Code -->',
    [COMMON_FLAGS.UNIP_EVENT_CODE_SNIPPET]:
        '<!-- Taboola Pixel Code -->\n' +
        '<script>\n' +
        "    _tfa.push({notify: 'event', name: 'event_name', id: <NUMERIC_ADVERTISER_ID>});\n" +
        '</script>\n' +
        '<!-- End of Taboola Pixel Code -->',
    [COMMON_FLAGS.UNIP_EVENT_CODE_SNIPPET_IMAGE_PIXEL_WITH_GTM]:
        "<img src='https://trc.taboola.com/<NUMERIC_ADVERTISER_ID>/log/3/unip?item-url={{Page URL}}&ref={{Referrer}}&en=event_name'\n" +
        "\twidth='0' height='0' style='display:none'/>",
    [COMMON_FLAGS.UNIP_EVENT_CODE_SNIPPET_IMAGE_PIXEL_WITHOUT_GTM]:
        "<img src='https://trc.taboola.com/<NUMERIC_ADVERTISER_ID>/log/3/unip?en=event_name'\n" +
        "\twidth='0' height='0' style='display:none' referrerpolicy='no-referrer-when-downgrade'/>",
    [COMMON_FLAGS.UNIP_BASE_IMAGE_PIXEL_DEFAULT_CODE_SNIPPET_WITH_GTM]:
        "<img src='https://trc.taboola.com/<NUMERIC_ADVERTISER_ID>/log/3/unip?en=page_view&item-url={{Page URL}}&ref={{Referrer}}'\n" +
        "\twidth='0' height='0' style='display:none'/>",
    [COMMON_FLAGS.UNIP_BASE_IMAGE_PIXEL_DEFAULT_CODE_SNIPPET_WITHOUT_GTM]:
        "<img src='https://trc.taboola.com/<NUMERIC_ADVERTISER_ID>/log/3/unip?en=page_view'\n" +
        "\twidth='0' height='0' style='display:none' referrerpolicy='no-referrer-when-downgrade'/>",
    [COMMON_FLAGS.TARGET_CPA_MAX_CAMPAIGN_LEARNING_TIME_DAYS]: 7,
    [COMMON_FLAGS.TARGET_CPA_MAX_CAMPAIGN_LEARNING_LIMITED_TIME_DAYS]: 10,
    [COMMON_FLAGS.CVR_LEARNING_STATUS_MAX_TIME_IN_REVIEW_IN_HOURS]: 24,
    [COMMON_FLAGS.CVR_LEARNING_STATUS_NUMBER_OF_CONVERSIONS_IN_TIMEFRAME_FOR_COMPLETION]: 50,
    [COMMON_FLAGS.LOOKBACK_WINDOW_FOR_CONVERSIONS_DAYS]: 7,
    [COMMON_FLAGS.CVR_LEARNING_STATUS_MAX_TIME_TO_SHOW_PROGRESS_AFTER_COMPLETION_IN_HOURS]: 24,
    [COMMON_FLAGS.CVR_LEARNING_STATUS_MIN_LEARNING_DAYS_BEFORE_WARNING]: 5,
    [COMMON_FLAGS.CVR_LEARNING_STATUS_MIN_LEARNING_PROGRESS_PERCENTAGE_BEFORE_WARNING]: 0.5,
    [COMMON_FLAGS.DCO_CREATIVE_TEMPLATE_REPORT_ENABLED]: 'false',
    [COMMON_FLAGS.DCO_ITEM_PERFORMANCE_REPORT_ENABLED]: 'false',
    [COMMON_FLAGS.STRIPE_PUBLIC_API_KEY]: 'pk_test_AOFxJkKcEyhD77xd3QSnglkL',
    [COMMON_FLAGS.SITE_BLOCKING_MAX_VALUE]: '1500',
    [COMMON_FLAGS.MOTION_ADS_WOCHIT_CHANNEL_ID]: 393216,
    [COMMON_FLAGS.RESUBMIT_CREATIVES_LANDING_PAGE_REJECTION_REASONS]: '',
    [COMMON_FLAGS.TARGET_CPA_ELIGIBILITY_LABELS]: 'false',
    [COMMON_FLAGS.PERFORMANCE_RECOMMENDATION_TCPA_SHOULD_USE_EDITABLE_CARD]: 'true',
    [COMMON_FLAGS.CUSTOM_CONTEXTUAL_REACH_THRESHOLD]: 10000,
    [COMMON_FLAGS.CAMPAIGN_REACH_ESTIMATOR_THRESHOLD]: 1000,
    [COMMON_FLAGS.CAMPAIGN_REACH_ESTIMATOR_LIMIT]: 1000000000,
    [COMMON_FLAGS.COMBINED_SEGMENTS_REACH_THRESHOLD]: 10000,
    [COMMON_FLAGS.COMBINED_SEGMENTS_REACH_LIMIT]: 1000000000,
    [COMMON_FLAGS.SRT_AUDIENCES_SUPPORTED_COUNTRIES_LIST]: 'US:United States,GB:United Kingdom',
    [COMMON_FLAGS.MRT_AUDIENCES_SUPPORTED_COUNTRIES_LIST]: 'US:United States,GB:United Kingdom',
    [COMMON_FLAGS.CRM_AUDIENCES_EMAILS_SUPPORTED_COUNTRIES_LIST]:
        'BR:Brazil,CA:Canada,IN:India,IL:Israel,JP:Japan,UK:United Kingdom,US:United States',
    [COMMON_FLAGS.CRM_AUDIENCES_DEVICE_IDS_SUPPORTED_COUNTRIES_LIST]:
        'CA:Canada,CO:Colombia,IL:Israel,JP:Japan,MX:Mexico,UK:United Kingdom,US:United States',
    [COMMON_FLAGS.EXTERNAL_AUDIENCES_CONTENT_REVIEW_ENABLED]: 'true',
    [COMMON_FLAGS.AUDIENCES_LONG_CREATION_TIME_INDICATION_ENABLED]: 'false',
    [COMMON_FLAGS.CAMPAIGN_LEVEL_CONVERSIONS_NUMBER_OF_CONVERSIONS_THRESHOLD]: -1,
    [COMMON_FLAGS.SCHEDULE_TRACKING_MEETING_URL]:
        'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0DxkncvhuDhKGDPXX0azrsFZWnuRvyjPuCqsu5qMvd_jMZ69qoxwmpV0sC4uC-SpCK5g74LUcd',
    [COMMON_FLAGS.PERMITTED_TIMEZONES_FOR_SCHEDULE_MEETING]: 'US/Eastern',
    [COMMON_FLAGS.CAMPAIGN_LEVEL_CONVERSIONS_DATA_LOOKBACK_WINDOW]: 45,
    [COMMON_FLAGS.IS_AUTO_BLOCKED_SITES_FORM_EDITABLE]: 'false',
    [COMMON_FLAGS.TARGET_CPA_SIGNIFICANT_CHANGE_PERCENT]: 0.5,
    [COMMON_FLAGS.NOTIFICATIONS_CENTER_REFECTH_TIME]: 60000,
    [COMMON_FLAGS.LEGAL_ENTITIES_REQUIRE_MANDATE_CONFIG]: '',
    [COMMON_FLAGS.LEGAL_ENTITIES_PARTIAL_CC_BRANDS_SUPPORT]: '',
    [COMMON_FLAGS.COUNTRY_TO_LEGAL_ENTITIES_WITH_TAX_REGISTRATION]: '',
    [COMMON_FLAGS.SUPPORTED_COUNTRY_FOR_TAX_REGISTRATION]: '',
    [COMMON_FLAGS.OUTCROPPING_IMAGE_NUM_IMAGES]: 4,
    [COMMON_FLAGS.OUTCROPPING_IMAGE_MIN_THRESHOLD]: 1.48,
    [COMMON_FLAGS.OUTCROPPING_IMAGE_MAX_THRESHOLD]: null,
    [COMMON_FLAGS.UNREALISTIC_TCPA_SHOULD_RECOMMEND_TARGET]: 'false',
    [COMMON_FLAGS.BID_MODIFICATION_DAY_TIME_BOOST_MIN_DEFAULT]: '0.1',
    [COMMON_FLAGS.PLATFORM_BOOST_MAX_VALUE]: 9,
    [COMMON_FLAGS.BACKSTAGE_MAIL_DOMAINS_RECOMMENDATIONS_VALUE]: 5,
    [COMMON_FLAGS.BACKSTAGE_MAIL_DOMAINS_RECOMMENDATIONS_FETCH_DURATION_MS]: 2000,
    [COMMON_FLAGS.PLATFORM_BOOST_MIN_VALUE]: 0.6,
    [COMMON_FLAGS.CROPPING_SIGNIFICANT_CHANGE_THRESHOLD_KEY]: 0.9,
    [COMMON_FLAGS.LOW_TIER_DAILY_LIMIT_VALIDATION_ENABLED]: 'false',
    [COMMON_FLAGS.GEN_AI_EDIT_DUPLICATE_TOOLTIP_MAX_CLOSES]: 5,
    [COMMON_FLAGS.BULK_UPLOAD_NUM_CAMPAIGNS_PER_BATCH]: 100,
    [COMMON_FLAGS.BULK_UPLOAD_NUM_CREATIVES_PER_BATCH]: 100,
    [COMMON_FLAGS.LOADING_BAR_TIME_FOR_REPLACE_BACKGROUND]: 25,
    [COMMON_FLAGS.TA_PIXEL_WITH_TIER_WARNINGS]: 'Low Touch',
    [COMMON_FLAGS.WIDE_PERFORMANCE_TABLE_DATA_RETENTION_IN_MONTHS]: 18,
    [COMMON_FLAGS.CHAT_AGENT_ENABLED]: 'true',
    [COMMON_FLAGS.USE_PUBLISHER_DESCRIPTION_PREFIX_FOR_PUBLISHER]: [
        1629109, 1629113, 1629149, 1629124, 1629600, 1629601, 1629819, 1629820, 1632963, 1632965, 1632966, 1632968,
        1632974, 1632975, 1632976, 1632979, 1632980, 1632981, 1632983, 1632984,
    ],
    [COMMON_FLAGS.BULK_UPLOAD_MAX_CREATIVES_ROWS]: 200,
    [COMMON_FLAGS.BULK_UPLOAD_MAX_CAMPAIGN_ROWS]: 200,
    [COMMON_FLAGS.MAX_ALLOWED_TERMS_NUMBER]: 300,
    [COMMON_FLAGS.MAX_CONVERSIONS_CPC_CAP_ENABLED]: 'false',
    [COMMON_FLAGS.MIN_PBP_ELIGIBLE_SEED_EVENT_THRESHOLD]: 300,
    [COMMON_FLAGS.SHOW_REGION_FOR_COUNTRIES]: ['US', 'CA', 'IN', 'AU'],
    [COMMON_FLAGS.ALLOW_CARTES_BANCAIRES]: 'false',
    [COMMON_FLAGS.MRT_AUDIENCES_PREFIXES_TO_REMOVE_FROM_INPUT]: '@, www., http://, https://',
    [COMMON_FLAGS.ADVANCED_PREVIEW_MAX_VARIATIONS]: 3,
    [COMMON_FLAGS.ADVANCED_PREVIEW_ENABLE_BUTTON_FOR_DISPLAY_AD]: 'false',
    [COMMON_FLAGS.ADVANCED_PREVIEW_ENABLE_BUTTON_FOR_DISPLAY_CREATE]: 'false',
    [COMMON_FLAGS.ADVANCED_PREVIEW_ENABLE_TRC_TABOOLA_PARAMS_IN_NATIVE]: 'false',
    [COMMON_FLAGS.ADVANCED_PREVIEW_FORCE_NATIVE_QUERY_PARAMS]: 'false',
    [COMMON_FLAGS.DISPLAY_SHOW_RESPONSIVE_CHECKBOX]: 'false',
    [COMMON_FLAGS.HIDE_VATID_TOOLTIP_FOR_COUNTRIES]: '',
    [COMMON_FLAGS.RBOX_IS_SUPPORTING_PREVIEW_HASH_PARAM]: 'false',
    [COMMON_FLAGS.ADVANCED_PREVIEW_WITH_TRANSFORMATION]: 'false',
    [COMMON_FLAGS.CHAT_AGENT_FIX_BUTTON_LOADING_TIMEOUT]: 10000,
    [COMMON_FLAGS.MIN_CREATIVES_ONBOARDING_JOURNEY]: 4,
    [COMMON_FLAGS.WARNING_THRESHOLD_MULTIPLIER]: 1.5,
    [COMMON_FLAGS.ONBOARDING_JOURNEY_WARNING_COMPTITIVE_CPA_THRESHOLD]: 5,
    [COMMON_FLAGS.ONBOARDING_JOURNEY_WARNING_CPA_TOO_LOW]: 1.5,
    [COMMON_FLAGS.ONBOARDING_JOURNEY_CPA_DEFAULT_TOLERANCE]: 20,
    [COMMON_FLAGS.ONBOARDING_JOURNEY_CREATIVES_WAITING_SCREEN_TIMEOUT]: 90000,
    [COMMON_FLAGS.ONBOARDING_JOURNEY_MIN_DAILY_BUDGET_FOR_CPC_MARKETING_OBJECTIVES]: 20,
    [COMMON_FLAGS.ONBOARDING_JOURNEY_MIN_DAILY_BUDGET_FOR_GENERAL_MARKETING_OBJECTIVES]: 5,
    [COMMON_FLAGS.PIXEL_TESTER_EVENTS_LIMIT]: 100,
    [COMMON_FLAGS.PIXEL_TESTER_EVENTS_BLACK_LIST_PARAMETERS]: ['data_source', 'click_account_id'],
    [COMMON_FLAGS.PIXEL_TESTER_DEFAULT_SHOPIFY_EVENTS]: [
        'page_view_http',
        'search_submitted_http',
        'product_view_http',
        'collection_view_http',
        'add_to_cart_http',
        'make_purchase_http',
        'cart_view_http',
    ],
    [COMMON_FLAGS.PIXEL_TESTER_WEBSOCKET_SOURCE_FILTER]: 'tracking-verification',
    [COMMON_FLAGS.PIXEL_TESTER_TFA_VALIDATION_ENABLED]: 'false',
    [COMMON_FLAGS.ONBOARDING_JOURNEY_WEBSOCKET_SOURCE_FILTER]: 'onboarding-journey',
    [COMMON_FLAGS.SHOW_STRIPE_LOGO_FOR_COUNTRIES]: ['US', 'CA', 'UK'],
    [COMMON_FLAGS.SHOW_FIXED_FEE_FOR_LEGAL_ENTITY]: [
        'TABOOLA_EUROPE',
        'TABOOLA_FRANCE',
        'TABOOLA_GERMANY',
        'TABOOLA_SPAIN',
    ],
    [COMMON_FLAGS.SHOW_CUSTOM_VAT_TOOLTIP_FOR_COUNTRIES]: ['BR', 'IL', 'IN', 'DE', 'ES'],
    [COMMON_FLAGS.APPLE_MAX_LENGTH_CREATIVE_TITLE_THRESHOLD]: 50,
    [COMMON_FLAGS.MAIL_MAX_LENGTH_CREATIVE_TITLE_THRESHOLD]: 50,
    [COMMON_FLAGS.MAIL_MAX_LENGTH_CREATIVE_DESCRIPTION]: 75,
    [COMMON_FLAGS.APPLE_MAX_LENGTH_CREATIVE_DESCRIPTION]: 100,
    [COMMON_FLAGS.PERFORMANCE_RULES_LOW_FREQUENCY_LOOK_BACK_WINDOW]: 90,
    [COMMON_FLAGS.PERFORMANCE_RULES_MEDIUM_FREQUENCY_LOOK_BACK_WINDOW]: 30,
    [COMMON_FLAGS.PERFORMANCE_RULES_HIGH_FREQUENCY_LOOK_BACK_WINDOW]: 30,
    [COMMON_FLAGS.CAMPAIGN_DEFAULT_EXCLUDE_SHOULD_EXCLUDE_AUDIENCES_WITH_NO_SIZE]: 'true',
    [COMMON_FLAGS.PACING_SCORE_STATUS_RANGE_BARRIERS]: [0.5, 0.95, 1.1, 1.5],
    [COMMON_FLAGS.PACING_SCORE_MIN_VALUE_TO_SHOW]: 0.01,
    [COMMON_FLAGS.CREATIVES_THUMBNAIL_DEFAULT_SRC]:
        'http://cdn.taboola.com/libtrc/static/thumbnails/88d908c6ffd9a29af6935b095fefc0a5.png',
    [COMMON_FLAGS.FREQUENCY_CAPPING_DAY_THRESHOLD]: 6,
    [COMMON_FLAGS.FREQUENCY_CAPPING_WEEK_THRESHOLD]: 15,
    [COMMON_FLAGS.FREQUENCY_CAPPING_MONTH_THRESHOLD]: 30,
    [COMMON_FLAGS.FREQUENCY_CAPPING_ALLOWED_TIERS]: '',
    [COMMON_FLAGS.PERFORMANCE_RULES_MAX_NUMBER_OF_SITE_NAMES]: 10,
    [COMMON_FLAGS.CAMPAIGN_SIMULATOR_ENABLED_BIDDING_STRATEGIES]: [
        BID_STRATEGIES.TARGET_CPA,
        BID_STRATEGIES.MAX_CONVERSIONS,
    ],
    [COMMON_FLAGS.CAMPAIGN_SIMULATOR_TCPA_UNREALISTIC_FACTOR]: 0.8,
    [COMMON_FLAGS.HIDDEN_CRA_TAGS_LIST]: '',
    [COMMON_FLAGS.CRA_TAG_COMMENT_CONTENT_BLACKLIST]: '',
    [COMMON_FLAGS.HOSTED_VIDEO_MIN_DURATION]: 5,
    [COMMON_FLAGS.HOSTED_VIDEO_MAX_DURATION]: 60,
    [COMMON_FLAGS.PREVIEW_POST_MESSAGE_ENABLE_NATIVE_ADS]: 'false',
    [COMMON_FLAGS.HOSTED_MEDIA_VIDEO_MAX_FILE_SIZE_IN_KILOBYTES]: FILE_SIZE_KILOBYTES.VIDEO,
    [COMMON_FLAGS.HOSTED_MEDIA_IMAGE_MAX_FILE_SIZE_IN_KILOBYTES]: FILE_SIZE_KILOBYTES.IMAGE,
    [COMMON_FLAGS.HOSTED_MEDIA_ARCHIVE_MAX_FILE_SIZE_IN_KILOBYTES]: FILE_SIZE_KILOBYTES.ARCHIVE,
    [COMMON_FLAGS.BULK_DUPLICATE_CAMPAIGNS_GROUPS_MAX_SIZE]: 10,
    [COMMON_FLAGS.DUPLICATE_CAMPAIGNS_MAX_COPIES]: 50,
    [COMMON_FLAGS.STANDARD_DISPLAY_AD_DIMENSIONS]: [
        '300x250',
        '300x600',
        '320x50',
        '728x90',
        '970x250',
        '160x600',
        '250x250',
        '720x1280',
    ],
    [COMMON_FLAGS.ENABLED_OPEN_TELEMETRY_UI]: 'true',
    [COMMON_FLAGS.SUPPLY_TARGETING_ICONS_TABOOLA_SELECT]: 'businessinsider,cbs,nbcsports,msn,apple',
    [COMMON_FLAGS.SUPPLY_TARGETING_MORE_ICONS_NUMBER_TABOOLA_SELECT]: '571',
    [COMMON_FLAGS.SUPPLY_TARGETING_ICONS_EXTENDED_PREMIUM]: 'businessinsider,cbs,nbcsports,msn,apple',
    [COMMON_FLAGS.SUPPLY_TARGETING_MORE_ICONS_NUMBER_EXTENDED_PREMIUM]: '571',
    [COMMON_FLAGS.SUPPLY_TARGETING_ICONS_TABOOLA_CURATED]:
        'businessinsider,cbs,nbcsports,msn,apple,apnews,foxsports,time,aol',
    [COMMON_FLAGS.SUPPLY_TARGETING_MORE_ICONS_NUMBER_TABOOLA_CURATED]: '5.1K',
    [COMMON_FLAGS.PIXEL_TESTER_TFA_VALIDATION_ENABLED]: 'false',
    [COMMON_FLAGS.PERFORMANCE_MEASUREMENT_REPORT_TYPE]:
        'day,campaign,site,creative,campaign-realtime,site-realtime,creative-realtime,audience',
    [COMMON_FLAGS.PERFORMANCE_MEASUREMENT_REPORT_DATE_RANGE]: 'SEVEN_DAYS,YESTERDAY,LIFETIME,REAL_TIME',
    [COMMON_FLAGS.PERFORMANCE_MEASUREMENT_ACCOUNT_TYPE]: 'PARTNER',
    [COMMON_FLAGS.PROFIT_MARGIN_MIN_VALUE_FOR_WARNING]: 0.15,
    [COMMON_FLAGS.CAMPAIGN_EDITOR_DRAWER_COLLAPSE_SECTIONS]: 'false',
    [COMMON_FLAGS.CODELESS_CRAWLER_API_TIMEOUT_MS]: 20000,
    [COMMON_FLAGS.PIXEL_TESTER_DELAY_INFO_MESSAGE]: 7,
    [COMMON_FLAGS.PIXEL_TESTER_SHOW_USER_MATCHING_CONSENT]: 'false',
};

export { COMMON_FLAGS, defaultCommonValues };
